import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './setorForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';

import { 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista,
	getListaUsuario
} from './setorActions';

const columns = [{
    field: 'nome_completo',
    type: 'text'
}, {
    field: 'abreviacao',
    type: 'text'
}, {
    field: 'nome_usuarios',
    type: 'text'
}, {
	field: 'nome_usuarios_supervisores',
    type: 'text'
}, {
	field: 'nome_usuarios_gestores',
    type: 'text'
}];

class Setor extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'nome_completo',
			direction: 'asc'
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaUsuario();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.nome_completo}
						${item.abreviacao}
						${item.nome_usuarios}
						${item.nome_usuarios_supervisores}
						${item.nome_usuarios_gestores}
					`.toUpperCase().includes(pesquisar.trim())
					);
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}

	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar();

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />

						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>

							<ExcelFile
								filename={'Setores'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item
								}))} name='Setores'>
									<ExcelColumn label='Nome' value='nome_completo' />
									<ExcelColumn label='Abreviação' value='abreviacao' />
									<ExcelColumn label='Usuários' value='nome_usuarios' />
									<ExcelColumn label='Supervisores' value='nome_usuarios_supervisores' />
									<ExcelColumn label='Gestores' value='nome_usuarios_supervisores' />
								</ExcelSheet>
							</ExcelFile>

						</div>
					</Row>

					<Table responsive border striped alturaFixa
						maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
							window.innerWidth < 1093 ? `${window.innerHeight - 300}px`
								: (
									window.innerWidth < 1799
										? `${window.innerHeight - 180}px`
										: (
											window.innerWidth < 4000
												? `${window.innerHeight - 180}px`
												: `${window.innerHeight - 110}px`
										)
								)
						)}>
						<THead>
							<Tr backgroundColor={'#1F3066'}
								color={'#ffffff'}
								height={47}>
								
								<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} width={10} alignCenter></Th>
								
								<ThSort
									field='nome_completo'
									label='Nome'
									width={300}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
								
								<ThSort
									field='abreviacao'
									label='Abreviação'
									width={100}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='nome_usuarios'
									label='Usuários'
									width={300}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='nome_usuarios_supervisores'
									label='Supervisores'
									width={300}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<ThSort
									field='nome_usuarios_gestores'
									label='Gestores'
									width={300}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />

								<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} width={50} alignCenter></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={item.id}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td color={'#000'} alignCenter bold>{item.id_setor_pai ? 'Sub' : <i class={item.icone}></i>}</Td>
									<Td color={'#000'} alignCenter small fontStyle={item.id_setor_pai ? 'italic' : null}>{item.ativo ? '':  'INATIVO - '}{item.nome_completo}</Td>
									<Td color={'#000'} alignCenter small fontStyle={item.id_setor_pai ? 'italic' : null}>{item.abreviacao}</Td>
									<Td color={'#000'} alignCenter small fontStyle={item.id_setor_pai ? 'italic' : null}>{item.nome_usuarios}</Td>
									<Td color={'#000'} alignCenter small fontStyle={item.id_setor_pai ? 'italic' : null}>{item.nome_usuarios_supervisores}</Td>
									<Td color={'#000'} alignCenter small fontStyle={item.id_setor_pai ? 'italic' : null}>{item.nome_usuarios_gestores}</Td>
									<Td minWidth={50} width={50} alignCenter>
										{item.ativo &&
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={true}
											small
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />}

										{(item.id_setor_pai && item.ativo) &&
										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={true}
											small
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.setor.aguardando,
	modoTela: state.setor.modoTela,
	lista: state.setor.lista,
	filtro: state.setor.filtro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista,
	getListaUsuario
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Setor);
